import json from './sprite.js';

export default {
    handle: 'es_SPT16-Costume-Box',
    label: 'es_SPT16-Costume-Box',
    json,
};
